import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import DynamicFormModal, { ENTITY_CONFIGS } from '../../../formBuilder/wrappers/DynamicFormModal';

export default class AddInstrument extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button className="btn btn-primary button-info-grid" onClick={() => this.handleShow()}>
                    <i className="fas fa-plus"></i> Add Instrument
                </button>
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Instrument</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicFormModal
                            entityType="instrument"
                            entityConfig={ENTITY_CONFIGS.instrument}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
